import { getPlaceDetails } from './taxi-and-limo-search-box';
import MarkerWithLabel from '@google/markerwithlabel';

let marker: google.maps.Marker;
let directionsDisplay: google.maps.DirectionsRenderer;
let originLng;
let destinationLng;
let isEast;

export function createMap() {
	const options = getMapOptions();

	const map = new google.maps.Map(document.querySelector('[data-map]'), options);

	const rendererOptions = {
		map,
		// replace default markers with black stroke circle icon markers
		markerOptions: {
			icon: {
				path: google.maps.SymbolPath.CIRCLE,
				fillOpacity: 1,
				fillColor: '#fff',
				scale: 4,
				strokeColor: '#002663',
				strokeWeight: 4
			}
		},
		polylineOptions: {
			strokeColor: '#002663',
			strokeWeight: 4
		},
		hideRouteList: true, // hide alternate routes
		suppressInfoWindows: true,
		preserveViewport: true // see comment in directionsService.route
	};

	directionsDisplay = new google.maps.DirectionsRenderer(rendererOptions);

	return map;
}

export function getDirectionsFromAirport(map: google.maps.Map, place: google.maps.GeocoderResult | google.maps.places.PlaceResult) {
	// define only once, as otherwise multiple routes are rendered.
	const directionsService = new google.maps.DirectionsService();

	let directionsRequest = {
		// Cannot use placeId for origin, as placeId has the potential to change.
		origin: 'Toronto Pearson International Airport, Mississauga, ON',
		destination: {
			placeId: place.place_id
		},
		travelMode: google.maps.TravelMode.DRIVING
	};

	// Take the direcetions request, an display the route
	directionsService.route(directionsRequest, (result, status) => {
		if (status == google.maps.DirectionsStatus.OK) {
			directionsDisplay.setDirections(result);

			// Due to route beecoming blurry when changing routes to/from far distances,
			// we stop the directionsRenderer from changing the map, and instead custom fit the map to the destination's bounds.
			const destinationBounds = result.routes[0].bounds;
			map.fitBounds(destinationBounds);

			originLng = result.routes[0].legs[0].start_location.lng();

			// remove previous marker
			if (marker) {
				clearMarker();
			}

			// add marker to destination
			const destinationPosition = result.routes[0].legs[0].end_location;

			// collecting this for determining position of label on "draw"
			destinationLng = destinationPosition.lng();

			isEast = originLng > destinationLng;

			if (!place) {
				return;
			}

			// add marker to destination
			makeMarker(map, destinationPosition, place);
		} else {
			window.alert('Directions request failed due to ' + status);
		}
	});
}

function clearMarker() {
	marker.setMap(null);
}

async function makeMarker(map: google.maps.Map, position: google.maps.LatLng, place: google.maps.GeocoderResult | google.maps.places.PlaceResult) {
	const placeDetails = await getPlaceDetails(place.place_id!);

	const streetNumber = getAddressComponent(placeDetails, 'street_number');
	const route = getAddressComponent(placeDetails, 'route');
	const locality = placeDetails.address_components!.find((address) => address.types.every((type) => type === 'locality' || type === 'political'));

	const labelContent = streetNumber && route ? `${streetNumber.long_name} ${route.long_name}` : locality ? `${locality.long_name}` : '';

	marker = new MarkerWithLabel({
		position,
		map,
		labelContent,
		labelAnchor: new google.maps.Point(20, 0),
		labelClass: `label-background ${isEast ? 'label-background--east' : ''}`,
		labelStyle: {
			border: 'none',
			'font-family': 'Source Sans, Open Sans, Helvetica, Arial, sans-serif',
			'font-size': '0.8125rem',
			transform: `${isEast ? 'translate(0, -50%)' : 'translate(-100%, -50%)'}`
		},
		icon: {
			url: '',
			scaledSize: new google.maps.Size(15, 22)
		},
		zIndex: 9999
	});
}

function getAddressComponent(place: google.maps.places.PlaceResult, type: string) {
	return place.address_components!.find((address) => address.types.findIndex((_type) => _type === type) !== -1);
}

function getMapOptions() {
	return {
		center: {
			lat: 43.6777,
			lng: -79.6248
		},
		zoom: 11,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		mapTypeControl: false,
		fullscreenControl: false,
		streetViewControl: false,
		styles
	} as google.maps.MapOptions;
}

// Map styles
const styles = [
	{
		featureType: 'administrative.locality',
		elementType: 'labels',
		stylers: [
			{
				lightness: 50
			}
		]
	},
	{
		featureType: 'administrative.neighborhood',
		elementType: 'labels',
		stylers: [
			{
				lightness: 50
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'labels.text',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'poi.business',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'poi.park',
		elementType: 'labels.text',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'road.arterial',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'road.highway',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'road.local',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'road.local',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'off'
			}
		]
	}
];
